// import { sha256 } from 'js-sha256';

export const hashPassword = (password: string, seed: string) => {
  // We will enable this feature when reset password feature implemented
  // return sha256.hex('thkee' + seed + password);
  return password;
}
